/**
 * @generated SignedSource<<a7d508949712f9d26317a4c7862b03be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CampaignInputAddressSearchMutation$variables = {
  postalCode: string;
};
export type CampaignInputAddressSearchMutation$data = {
  readonly postalCode: {
    readonly __typename: "MPostalCode";
    readonly city: string;
    readonly mPrefectureName: string;
    readonly postalCode: string;
    readonly town: string | null;
  } | {
    readonly __typename: "PostalCodeError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type CampaignInputAddressSearchMutation = {
  response: CampaignInputAddressSearchMutation$data;
  variables: CampaignInputAddressSearchMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "postalCode"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "postalCode",
        "variableName": "postalCode"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mPrefectureName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "town",
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "PostalCodeError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CampaignInputAddressSearchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "postalCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "type": "MPostalCode",
            "abstractKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CampaignInputAddressSearchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "postalCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "MPostalCode",
            "abstractKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a93941917232899948fc4acf027aeec6",
    "id": null,
    "metadata": {},
    "name": "CampaignInputAddressSearchMutation",
    "operationKind": "mutation",
    "text": "mutation CampaignInputAddressSearchMutation(\n  $postalCode: String!\n) {\n  postalCode(input: {postalCode: $postalCode}) {\n    __typename\n    ... on MPostalCode {\n      postalCode\n      mPrefectureName\n      city\n      town\n      id\n    }\n    ... on PostalCodeError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ccfa63886bb4a6c29dd605d76168437";

export default node;
